const selectPhoneTypeOptions = [
  { id: '1', name: 'Residencial' },
  { id: '2', name: 'Celular' },
  { id: '3', name: 'Comercial' },
  { id: '', name: 'Não informado' },
];

export default selectPhoneTypeOptions;
